<form (ngSubmit)="editClient()" [formGroup]="formClient">
  <app-toolbar [createdAt]="client()?.attributes?.createdAt ?? ''" [updatedAt]="client()?.attributes?.updatedAt ?? ''"
    (edit)="editClient()" (delete)="deleteClient()"></app-toolbar>

  <p-card>
    <p-tabView>
      <p-tabPanel header="Datos" leftIcon="pi pi-user">
        <div class="grid">
          <div class="col-12 md:col-6">
            <app-input label="Nombre" placeholder="Nombre" name="name"
              [control]="formUtilities.getControl(formClient, 'name')"></app-input>
          </div>
          <div class="col-12 md:col-6">
            <app-input label="Nombre contacto" placeholder="Nombre contacto" name="name_contact"
              [control]="formUtilities.getControl(formClient, 'name_contact')"></app-input>
          </div>
          <div class="col-12 md:col-6">
            <app-input label="Email" placeholder="Email" name="email"
              [control]="formUtilities.getControl(formClient, 'email')"></app-input>
          </div>
          <div class="col-12 md:col-6">
            <app-input label="Teléfono" placeholder="Teléfono" name="phone"
              [control]="formUtilities.getControl(formClient, 'phone')"></app-input>
          </div>
          <div class="col-12 md:col-6">
            <app-input label="Teléfono opcional" placeholder="Teléfono opcional" name="phone_optional"
              [control]="formUtilities.getControl(formClient, 'phone_optional')"></app-input>
          </div>
          <div class="col-12 md:col-6">
            <app-input label="Dirección" placeholder="Dirección" name="address"
              [control]="formUtilities.getControl(formClient, 'address')"></app-input>
          </div>
          <div class="col-12 md:col-6">
            <app-input label="Ciudad" placeholder="Ciudad" name="city"
              [control]="formUtilities.getControl(formClient, 'city')"></app-input>
          </div>
          <div class="col-12 md:col-6">
            <app-input label="Provincia" placeholder="Provincia" name="province"
              [control]="formUtilities.getControl(formClient, 'province')"></app-input>
          </div>
          <div class="col-12 md:col-6">
            <app-input label="Código postal" placeholder="Código postal" name="postal_code"
              [control]="formUtilities.getControl(formClient, 'postal_code')"></app-input>
          </div>
          <div class="col-12 md:col-6">
            <app-input label="NIF/CIF" placeholder="NIF/CIF" name="nif_cif"
              [control]="formUtilities.getControl(formClient, 'nif_cif')"></app-input>
          </div>
        </div>
      </p-tabPanel>

      <p-tabPanel header="Personas de contacto" leftIcon="pi pi-users">
        <app-contact-people [contacts]="contacts()" [idClient]="idClient()" (contactAdded)="onContactAdded($event)"
          (contactUpdated)="onContactUpdated($event)" (contactDeleted)="onContactDeleted($event)"></app-contact-people>
      </p-tabPanel>

      <p-tabPanel header="Agente" leftIcon="pi pi-user">
        <app-agent [agent]="agent()" (agentSelected)="onAgentSelected($event)" (agentRemoved)="onAgentRemoved()"></app-agent>
      </p-tabPanel>
    </p-tabView>
  </p-card>
</form>